export default __webpack_public_path__ + "static/dairy-free-health-1-mobile-c83b92f80b41ba98c6b0bb47a893a9a4.png";